import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUProfessions() {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUProfessions,
      params: [ edition_id ],
      condition: !!edition_id,
      cache_name: "azzu_professions",
      resultDataHandler: data => data.map( p => ({
         value: p.id,
         label: p.name,
         industry_id: p.industry?.id
      }))
   })
}